import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { ChangeEvent, useEffect, useState, Dispatch } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useSession, xapi } from '../../hooks/session';
import SwLoading from './spinner/SwLoading';
import mapPinIcon from '../../images/sub/map_pin.svg';
import openBookIcon from '../../images/sub/open_book.svg';
import walkingManIcon from '../../images/sub/waking_man.svg';
import {
  KEY_USER_READ_LIST,
  KEY_USER_STEP_LIST,
  KEY_USER_WRITE_LIST,
} from '../../common/key';

import {
  commaFormat,
  convert2Date,
  DATE_LOCALE_OFFSET,
  encodeSearchWord,
  firstDayOfMonth,
  formatDateString,
  getCurrentStartDate,
  lastDayOfMonth,
} from '../../common/helper';
import {
  getUserReadList,
  getUserStepList,
  getUserWriteList,
} from '../../common/api/ApiUser';
import { SwSelectMonth } from './SwSelectMonth';
import NoDataPage from './NoDataPage';
import { EmptyPage } from './EmptyPage';
import { SwPagination } from './tableElement/SwPagination';

interface Props {}

export const SwMedalLegend: React.FC<Props> = () => {
  const show = true;

  return (
    <Box display='flex' justifyContent='center' gap={3} mb={2}>
      {/* 금 */}
      <Box display='flex' alignItems='center'>
        <Box
          sx={{
            width: 12,
            height: 12,
            mr: 0.5,
            borderRadius: 1,
            background: 'linear-gradient(90deg, #f7db07 5%, #ebf08e 95%)',
          }}
        />
        <Typography variant='body2'>금</Typography>
      </Box>

      {/* 은 */}
      <Box display='flex' alignItems='center'>
        <Box
          sx={{
            width: 12,
            height: 12,
            mr: 0.5,
            borderRadius: 1,
            background: 'linear-gradient(90deg, #dadbdd 5%, #92BDFF 95%)',
          }}
        />
        <Typography variant='body2'>은</Typography>
      </Box>

      {/* 동 */}
      <Box display='flex' alignItems='center'>
        <Box
          sx={{
            width: 12,
            height: 12,
            mr: 0.5,
            borderRadius: 1,
            background: 'linear-gradient(90deg, #62f667 5%, #9df3aa 95%)',
          }}
        />
        <Typography variant='body2'>동</Typography>
      </Box>

      {/* 전체 */}
      <Box display='flex' alignItems='center'>
        <Box
          sx={{
            width: 12,
            height: 12,
            mr: 0.5,
            borderRadius: 1,
            background: 'linear-gradient(90deg, #FF4975 5%, #FFA88C 95%)',
          }}
        />
        <Typography variant='body2'>전체</Typography>
      </Box>
    </Box>
  );
};
